import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBrochure, IBrochureInitialState } from "./brochureModel";
import {
  ActiveInactiveBrochure,
  createBrochure,
  deleteBrochure,
  deleteBrochureAttachment,
  getAllBrochures,
  getBrochureByID,
  updateBrochure,
  uploadBrochureAttachments,
} from "./services/brochure.services";

const initialState: IBrochureInitialState = {
  loading: false,
  error: "",
  BrochureList: [],
  BrochureAttachmentDeleteIndex: -1,
  BrochureID: null,
  BrochureAttachmentID: null,
  BrochureDetail: {
    SectorID: null,
    IsActive: 1,
  },
  FilterBrochure: {
    SectorName: "",
  },
};

const brochureSlice = createSlice({
  name: "brochure",
  initialState,
  reducers: {
    clearBrochureDetails: (state) => {
      state.BrochureDetail = initialState.BrochureDetail;
    },
    setBrochureID: (state, action) => {
      state.BrochureID = action.payload;
    },
    clearBrochureID: (state) => {
      state.BrochureID = initialState.BrochureID;
    },
    setBrochureAttachmentID: (state, action) => {
      state.BrochureAttachmentID = action.payload;
    },
    clearBrochureAttachmentID: (state) => {
      state.BrochureAttachmentID = initialState.BrochureAttachmentID;
    },
    setFilterBrochure: (state, action) => {
      state.FilterBrochure = action.payload;
    },
    clearFilterBrochure: (state) => {
      state.FilterBrochure = initialState.FilterBrochure;
    },
    setBrochureAttachmentDeleteIndex: (state, action) => {
      state.BrochureAttachmentDeleteIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBrochures.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBrochures.fulfilled,
      (state, action: PayloadAction<IBrochure[]>) => {
        state.loading = false;
        state.BrochureList = action.payload || [];
      }
    );
    builder.addCase(getAllBrochures.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BrochureList = [];
    });

    builder.addCase(createBrochure.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createBrochure.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(createBrochure.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateBrochure.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateBrochure.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateBrochure.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBrochure.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBrochure.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBrochure.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBrochureByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBrochureByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.BrochureDetail = action.payload;
    });
    builder.addCase(getBrochureByID.rejected, (state, action) => {
      state.loading = false;
      state.BrochureDetail = initialState.BrochureDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(ActiveInactiveBrochure.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBrochure.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBrochure.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(uploadBrochureAttachments.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(uploadBrochureAttachments.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(uploadBrochureAttachments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBrochureAttachment.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBrochureAttachment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBrochureAttachment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearBrochureDetails,
  setBrochureID,
  clearBrochureID,
  setBrochureAttachmentID,
  clearBrochureAttachmentID,
  setFilterBrochure,
  clearFilterBrochure,
  setBrochureAttachmentDeleteIndex,
} = brochureSlice.actions;
export default brochureSlice.reducer;
